import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { GenericIconButton, GenericModal, GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

import DateTime from "./DateTime.jsx";
import MenuItemNodes from './MenuItemNodes';
import ModalNoAutorizado from './ModalNoAutorizado.jsx'

const MenuProductos = (props) => {
    const { productoActual, menuProductos, globalState, cerrarSesion, userId } = props;
    const { menuUsuario } = menuProductos;

    if (globalState === null)
        return null;

    let changePassLabel = "Cambiar mi contrase\u00F1a";
    let changeHomePage = "Cambiar mi p\u00E1gina de inicio";
    let endSession = "Cerrar sesi\u00F3n";
    let formattedDate = new Date();

    if (productoActual === null || productoActual === undefined)
        return null;

    const productToLower = productoActual.toLowerCase();


    function popUp() {
        props.accesoDirectoPopUpPrograma(menuProductos.defaultProducto);
    }

    return (
        <div>
            <div className={"navbar-inverse navbar-fixed-top " + productToLower} role="navigation" >
                <div className="container icons">
                    <div className="row">
                        <div className="col-xs-3">
                            {<DateTime initialTime={menuProductos.tiempo} />}
                        </div>
                        <div className="col-xs-3">
                            <span className="ti-home portico"></span>
                            <span className="span-color-top-bar">{globalState.branchCode}</span>
                        </div>
                        <div className="col-xs-3">
                            <span className="ti-user portico"></span>
                            <span className="span-color-top-bar">{menuProductos.login}</span>
                        </div>
                        <div className="col-xs-3">
                            <span className="ti-layout-media-center-alt portico"></span>
                            <span className="span-color-top-bar">{globalState.terminalId} {menuProductos.hostName}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className={"nav-bar navbar navbar-inverse navbar-static-top menu-product " + productToLower} role="navigation">
                <div className="container">
                    <div className="navbar-header">
                        <button type="button" className="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </button>
                        <div className="image-gyf-header"></div>
                    </div>
                    <div className="collapse navbar-collapse">
                        <ul className="nav navbar-nav no-overflow-y">
                            <li className="dropdown">
                                <a href="#" className="dropdown-toggle product-portico" data-toggle="dropdown">
                                    <div className="product-container">
                                        <p>
                                            {productoActual.toUpperCase()} <b className="caret pull-right arrow-product"></b>
                                        </p>
                                        {/*(productoActual.toUpperCase() != "PRODUCTOS") &&
                                            <p className="version-label">
                                                VERSION 1.10
                                                </p>
                                        */}
                                    </div>
                                </a>
                                <MenuItemNodes menuUsuario={menuUsuario} />
                            </li>
                        </ul>

                        <ul className="nav navbar-nav no-overflow-y pull-right">
                            <li className="dropdown">
                                <a href="#" className="dropdown-toggle" data-toggle="dropdown">
                                    {menuProductos.userName}
                                    <b className="caret"></b>
                                </a>

                                {(props.menuProductos.productosCount <= 1) &&
                                    (<ul className="dropdown-menu user-menu">
                                        <li>
                                            <Link to={"/cambiocontrasena/" + userId}
                                                activeClassName="active">{changePassLabel}</Link>
                                        </li>
                                        <li className="divider no-margin-bottom"></li>
                                        {(props.menuProductos.solicitarCotrasenia || props.menuProductos.tipoSeguridad == 'GYF') && (<li className="session-li">
                                            <button className="btn btn-default pull-right" onClick={() => cerrarSesion()}>{endSession}</button>
                                        </li>)}
                                    </ul>)
                                }

                                {(props.menuProductos.productosCount > 1) &&
                                    (<ul className="dropdown-menu user-menu">
                                        <li>
                                            <Link to={"/cambiocontrasena/" + userId}
                                                activeClassName="active">{changePassLabel}</Link>
                                        </li>
                                        <li className="divider"></li>
                                        <li>
                                            <a href="#" className="clickable" onClick={() => popUp()}>{changeHomePage}</a>
                                        </li>
                                        <li className="divider no-margin-bottom"></li>
                                        {((!props.menuProductos.soloUsuarioLoggeado || props.menuProductos.solicitarContrasenia
                                            || props.menuProductos.tipoSeguridad == 'GYF') && (
                                            <li className="session-li">
                                                <button className="btn btn-default pull-right" onClick={() => cerrarSesion()}>{endSession}</button>
                                            </li>))}
                                    </ul>)
                                }
                            </li>
                            <li>
                                <GenericIconButton iconType="glyphicon glyphicon-bell color-white" buttonType="nav-bar-bell" />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {/*MODAL DE INACTIVIDAD*/}
            <GenericModal type="ALL_CUSTOM"
                className="modal fade-out"
                id="idleUserModal"
                screenSize="modal-dialog modal-generic"
                header={<h2 className="modal-title">Control de sesi&oacute;n activa</h2>}
                footer={
                    <div className="row">
                        <div className="col-xs-4">
                            <GenericSimpleButton text="Volver al sistema"
                                buttonClass="btn btn-default btn-secondary"
                                onClick={() => { $("#idleUserModal").modal('toggle') }} />
                        </div>
                    </div>}
                body={<p>La sesi&oacute;n finalizar&aacute; autom&aacute;ticamente por inactividad del usuario.</p>} />
            <ModalNoAutorizado />
        </div>
    );
}

export default MenuProductos;


// WEBPACK FOOTER //
// ./Portico/App/Screens/MenuProductos/components/MenuProductos.jsx